// src/api/payment/payment.js
import { API_BASE } from '../../utils/api';

// kick off Stripe Checkout
export async function createCheckoutSession(payload) {
  const res = await fetch(`${API_BASE}/api/create-checkout-session`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const message =
      data?.message ||
      data?.error ||
      'Failed to create Stripe session';
    throw new Error(message);
  }

  return res.json();
}